<template>
  <div id="user-management">
    <div id="user-title">
      <a-icon type="arrow-left" @click="goBack" />
      <h1>User Management</h1>
      <a-button @click="createUser">Create User</a-button>
    </div>
    <a-table
      v-if="!loadingData"
      :rowKey="record => record.Username"
      :columns="columns"
      :dataSource="data"
      :pagination="false"
      :loading="loadingData"
    >
      <template slot="user-created-date" slot-scope="createdAt">{{formatDate(createdAt)}}</template>
      <template slot="user-updated-date" slot-scope="updatedAt">{{formatDate(updatedAt)}}</template>
      <template slot="enabled" slot-scope="enabled, record">
        <a-switch :defaultChecked="enabled" @change="isStatusChanged(record, $event)"></a-switch>
      </template>
    </a-table>

    <a-spin size="large" v-if="loadingData"></a-spin>
    <a-modal
      title="User Information"
      :visible="modalVisible"
      :confirm-loading="modalLoading"
      @cancel="toggleModal"
      width="50vw"
    >
      <template slot="footer">
        <a-button key="back" @click="toggleModal">Cancel</a-button>
        <a-button
          @click="saveUser"
          :loading="savingUser"
          class="create-button"
          type="primary"
        >{{ savingUser ? "Saving" : "Save" }}</a-button>
      </template>
      <div class="modal-body">
        <a-form id="modal-form" v-if="!modalLoading">
          <a-form-item
            label="Email"
            :label-col="{ span: 6 }"
            :wrapperCol="{ span: 16 }"
            :help="errorMsg.email"
          >
            <a-input v-model="selectedUser.email" />
          </a-form-item>
          <a-form-item
            label="Temporary Password"
            :label-col="{ span: 6 }"
            :wrapperCol="{ span: 16 }"
            :help="errorMsg.temporaryPassword"
          >
            <a-input v-model="selectedUser.temporaryPassword" />
          </a-form-item>
        </a-form>
      </div>
    </a-modal>
  </div>
</template>
<script>
import axios from "axios";
import { mapState } from "vuex";

const columns = [
  {
    title: "Cognito Id",
    dataIndex: "Username",
    sorter: (a, b) => sortFields(a.Username, b.Username),
    scopedSlots: { customRender: "cognito-id" },
  },
  {
    title: "Email",
    dataIndex: "email",
    key: "Email",
    scopedSlots: { customRender: "email" },
  },
  {
    title: "Status",
    dataIndex: "UserStatus",
    scopedSlots: { customRender: "user-status" },
  },
  {
    title: "Enabled",
    dataIndex: "Enabled",
    scopedSlots: { customRender: "enabled" },
  },
  {
    title: "Date Created",
    dataIndex: "UserCreateDate",
    scopedSlots: { customRender: "user-created-date" },
  },
  {
    title: "Date Modified",
    dataIndex: "UserLastModifiedDate",
    scopedSlots: { customRender: "user-updated-date" },
  },
];

export default {
  computed: { ...mapState(["user", "apiUrl"]) },
  data() {
    return {
      columns,
      modalVisible: false,
      modalLoading: false,
      loadingData: true,
      isCreateNew: false,
      savingUser: false,
      errorMsg: {},
      testData: {
        Users: [
          {
            Username: "1cb32844-a0c3-4058-903c-a5c61189ac57",
            Attributes: [
              {
                Name: "sub",
                Value: "1cb32844-a0c3-4058-903c-a5c61189ac57",
              },
              {
                Name: "email_verified",
                Value: "true",
              },
              {
                Name: "email",
                Value: "mariacharlenereyes@gmail.com",
              },
            ],
            UserCreateDate: "2020-05-14T23:06:30.694Z",
            UserLastModifiedDate: "2020-05-15T02:02:44.268Z",
            Enabled: true,
            UserStatus: "CONFIRMED",
          },
          {
            Username: "3fdec0b4-1468-4c85-a600-cceeb521bf4b",
            Attributes: [
              {
                Name: "sub",
                Value: "3fdec0b4-1468-4c85-a600-cceeb521bf4b",
              },
              {
                Name: "email_verified",
                Value: "true",
              },
              {
                Name: "email",
                Value: "martin@chocsproc.com",
              },
            ],
            UserCreateDate: "2020-05-14T23:07:04.870Z",
            UserLastModifiedDate: "2020-05-18T05:18:25.523Z",
            Enabled: true,
            UserStatus: "CONFIRMED",
          },
        ],
      },
      data: [],
      selectedUser: {},
    };
  },
  mounted() {
    this.fetchUsers();
  },
  methods: {
    fetchUsers() {
      this.loadingData = true;
      axios({
        url: `${this.apiUrl}/users`,
        headers: {
          Authorization: this.user.signInUserSession.idToken.jwtToken,
        },
        params: {
          action: "LIST_USERS",
        },
      }).then((resp) => {
        console.log(JSON.stringify(resp.data));
        if (resp.data.Users) {
          resp.data.Users.forEach((item) => {
            let { Attributes, ...user } = item;
            user.CognitoId = item.CognitoId;
            user = { ...user, ...this.extractAttributes(item.Attributes) };
            item.Attributes.forEach((attr) => {
              user[attr.Name] = attr.Value;
            });
            this.data.push(user);
          });
          console.log(this.data);
        }

        this.loadingData = false;
      });
    },
    goBack() {
      this.$router.go(-1);
    },
    formatDate(d) {
      const date = new Date(d);
      return date.toLocaleString();
    },
    toggleModal() {
      this.modalVisible = !this.modalVisible;
    },
    getUser(cognitoId) {
      this.modalLoading = true;
      this.modalVisible = true;

      axios({
        url: `${this.apiUrl}/users`,
        headers: {
          Authorization: this.user.signInUserSession.idToken.jwtToken,
        },
        params: {
          action: "GET_USER",
          CognitoId: cognitoId,
        },
      }).then((resp) => {
        if (resp.status == 200 && resp.data) {
          let { UserAttributes, ...user } = resp.data;
          user = { ...this.extractAttributes(UserAttributes), ...user };
          console.log(user);
          this.selectedUser = user;
        }
        this.modalLoading = false;
      });
    },
    extractAttributes(attributes) {
      let attribute = {};
      attributes.forEach((attr) => {
        attribute[attr.Name] = attr.Value;
      });
      return attribute;
    },
    createUser() {
      this.modalVisible = true;
      this.selectedUser = {};
      this.isCreateNew = true;
    },
    saveUser() {
      this.savingUser = true;
      const { email, temporaryPassword } = this.selectedUser;
      let errorCount = 0;
      // validate email
      const emailRegex = /\S+@\S+\.\S+/;
      if (this.isFieldError("email", email, emailRegex, 4, 256)) {
        errorCount++;
      } else {
        this.errorMsg.email = "";
      }
      // validate temp password
      if (
        this.isFieldError("temporaryPassword", temporaryPassword, null, 6, 256)
      ) {
        errorCount++;
      } else {
        this.errorMsg.temporaryPassword = "";
      }
      // ready to submit
      if (errorCount == 0) {
        axios({
          url: `${this.apiUrl}/users`,
          method: "post",
          headers: {
            Authorization: this.user.signInUserSession.idToken.jwtToken,
          },
          params: {
            action: "CREATE_USER",
            temporaryPassword,
            email,
            username: email,
          },
        })
          .then((resp) => {
            console.log(resp);
            if (resp.data.status == 500) {
              alert(resp.data.message);
            } else {
              this.toggleModal();
              this.data = [];
              this.fetchUsers();
              this.isCreateNew = false;
            }
            this.savingUser = false;
          })
          .catch((err) => {
            console.log(err);
            alert(err);
          });
      }
    },
    isFieldError(field, value, regex, minLength, maxLength) {
      if (regex && !regex.test(value)) {
        this.errorMsg[field] = `Invalid ${field}`;
        return true;
      } else if (
        value == null ||
        value.length < minLength ||
        value.length > maxLength
      ) {
        this.errorMsg[
          field
        ] = `Invalid ${field}. Min length is ${minLength}. Max length is ${maxLength}`;
        return true;
      }
      return false;
    },
    isStatusChanged(rec, val) {
      axios({
        url: `${this.apiUrl}/users`,
        method: "post",
        headers: {
          Authorization: this.user.signInUserSession.idToken.jwtToken,
        },
        params: {
          action: val ? "ENABLE_USER" : "DISABLE_USER",
          username: rec.Username,
        },
      });
    },
  },
};
</script>
<style lang="scss">
#user-management {
  #user-title {
    display: flex;
    align-items: center;
    flex-direction: row;
    margin-bottom: 10px;

    h1 {
      margin: 10px 10px;
    }
  }
  #modal-form {
    margin-top: 50px;
    display: flex;
    flex-direction: column;
  }
}
</style>